<template>
  <div
    class="contact-view min-h-screen bg-gradient-to-br from-[#0b105d] via-[#0b105d]/90 to-[#fe6d0d]/20 overflow-x-hidden"
  >
    <!-- Hero Section -->
    <ContactHeroSection />

    <!-- Contact Form and Info Section -->
    <section class="py-12 sm:py-16 md:py-20 relative z-10">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12">
        <div
          class="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-start max-w-6xl lg:max-w-7xl mx-auto"
        >
          <!-- Contact Form -->
          <ContactFormSection />

          <!-- Contact Info -->
          <ContactInfoSection />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import ContactFormSection from '@/components/sections/contact/ContactFormSection.vue'
import ContactHeroSection from '@/components/sections/contact/ContactHeroSection.vue'
import ContactInfoSection from '@/components/sections/contact/ContactInfoSection.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { onMounted } from 'vue'

onMounted(() => {
  AOS.init({
    duration: 1000,
    once: true,
    easing: 'ease-out-cubic',
  })
})
</script>
